import React from 'react';
import { useParams } from 'react-router-dom';
import FieldForm from '@/components/admin/field/FieldForm';

const EditField: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  return <FieldForm mode="edit" fieldSlug={slug} />;
};

export default EditField;
